/*
 * Copyright © 2025 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
import {inject, Injectable} from '@angular/core';
import {UIRouter} from '@uirouter/core';

export type QueryParamsHandling = 'merge' | 'replace';

/**
 * @property queryParamsHandling 'merge' keeps existing params, 'replace' overwrites (defaults to 'merge')
 * @property replaceUrl true replaces history entry, false pushes a new one (defaults to false)
 */
export interface RouterParamsOptions {
    queryParamsHandling?: QueryParamsHandling;
    replaceUrl?: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class RouterParamsSyncerService {

    private router = inject(UIRouter);

    public updateRouterParamsOnce(
        params: Record<string, unknown>,
        options: RouterParamsOptions = {},
    ): void {
        const {queryParamsHandling = 'merge', replaceUrl = false} = options;

        const inherit = queryParamsHandling === 'merge';
        const location = replaceUrl ? 'replace' : true;

        this.router.stateService.go('.', params, {reload: false, location, inherit});
    }
}
